import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full z-50 bg-[#8B0000] text-white py-1.5 px-4 shadow-md font-body leading-tight" data-id="element-112">
      <div className="max-w-4xl mx-auto flex flex-col items-center justify-center gap-0" data-id="element-113">
        <p className="text-[11px] md:text-base flex flex-wrap items-center justify-center gap-x-1.5 leading-snug" data-id="element-114">
          <AlertTriangle className="text-[#FFD700] w-3.5 h-3.5 md:w-4 md:h-4 inline-block shrink-0" data-id="element-115" />
          <span className="font-bold italic" data-id="element-116">OFERTA DE LANZAMIENTO:</span>
          <span data-id="element-117">El 87% de descuento expira en</span>
          <span className="text-[#FFD700] font-bold text-sm md:text-xl drop-shadow-[0_0_8px_rgba(255,215,0,0.5)] leading-none" data-id="element-118">
            {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </p>

        <p className="font-bold text-[11px] md:text-base leading-snug" data-id="element-119">
          Consigue el Protocolo Completo por solo{' '}
          <span className="text-[#FFD700]" data-id="element-120">26,00 €.</span>
        </p>
      </div>
    </div>;
}